<template>
  <PrePaidListPlans
    v-if="prePaidStore.plansFastpris.length > 0"
    header="Fastpris"
    :ingress="configData.FastprisIngress"
    :text="configData.FastprisText"
    :plans="prePaidStore.plansFastpris"
    :selected-plan-id="
      (
        prePaidStore.plansFastpris.find((x) =>
          x.ProductName.includes(DEFAULT_PREPAID_NAME_IDENTIFIER),
        )?.ProductId ??
        prePaidStore.plansFastpris[0].ProductId ??
        DEFAULT_PREPAID_NAME_IDENTIFIER
      ).toString()
    "
    type="fastpris"
  />
  <PrePaidListPlans
    v-if="prePaidStore.plansSaldo.length > 0"
    header="Saldo"
    :ingress="configData.GoIngress"
    :text="configData.GoText"
    :plans="prePaidStore.plansSaldo"
    :selected-plan-id="
      (
        prePaidStore.plansSaldo.find((x) =>
          x.ProductName.includes(DEFAULT_PREPAID_SALDO_IDENTIFIER),
        )?.ProductId ??
        prePaidStore.plansSaldo[0]?.ProductId ??
        DEFAULT_PREPAID_SALDO_IDENTIFIER
      ).toString()
    "
    type="saldo"
  />
  <div
    v-if="prePaidStore.plansStartpaket.length > 0"
    class="bg-surface-tertiary rounded-md p-16 flex flex-col gap-8 my-24 lg:my-32 md:items-center md:flex-row md:p-24 lg:p-48"
  >
    <div class="flex flex-col gap-8">
      <h2 class="heading-xs">Vill du beställa ett tomt kontantkort?</h2>
      <p>Ett kontantkort med mobilnummer, men utan någon laddning</p>
    </div>
    <div class="w-full md:ml-auto md:w-fit">
      <AppButton
        color="primary"
        size="default"
        full-width
        @click="goToCheckout()"
        @keyup.enter.self.prevent="goToCheckout()"
        @keyup.space.self.prevent="goToCheckout()"
      >
        Beställ nu!</AppButton
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AddBundleToCartRequestModel } from '~/models/shopping_cart/AddBundleToCartRequest.api.model';
import { PrePaidListPlans } from '#components';
import {
  DEFAULT_PREPAID_NAME_IDENTIFIER,
  DEFAULT_PREPAID_SALDO_IDENTIFIER,
} from '~/utils/pdp/queryParamHelpers';
const notifications = useNotificationStore();
const { $api } = useNuxtApp();
const prePaidStore = usePrePaidStore();

interface Props {
  configData: {
    FastprisIngress?: string;
    FastprisText?: string;
    GoIngress?: string;
    GoText?: string;
    DefaultOpen?: boolean;
  };
}

const { pushAddToCartEvent } = useGoogleAnalyticsEvents();
defineProps<Props>();

const goToCheckout = async () => {
  prePaidStore.setPlanId(prePaidStore.plansStartpaket[0].ProductId.toString());
  const bundle =
    prePaidStore.plansStartpaket[0]?.Variants?.[0]?.Prices?.BundlePrices?.[0];

  if (bundle?.BundlePriceId) {
    try {
      const requestPayload: AddBundleToCartRequestModel = {
        BundlePriceId: +bundle?.BundlePriceId,
        DownPayTime: 1,
      };
      await $api.ShoppingCartModule.AddBundleToCart(requestPayload);
      pushAddToCartEvent(prePaidStore.trackingData);
      navigateTo('/shop/varukorg', { external: true });
    } catch (e) {
      notifications.setStandardErrorNotification();
    }
  }
};
</script>
